import React from 'react';
import {Modal, Form, Button, Checkbox} from 'antd';
import StationTableNonAction from './StationTableNonAction';
import StationTableMobileNonAction from './StationTableMobileNonAction';
const FormItem = Form.Item;

class SystemHubUpgradeStationModalForm extends React.Component {
  handleSelectedKeys = (selectedKeys) => {
    const {form} = this.props
    form.setFieldsValue({selectedKeys: selectedKeys});
  }

  render() {
    const {
      hub,
      stations,
      groups,
      title,
      visible,
      onCancel,
      onSubmit,
      form,
      isMobile
    } = this.props

    const actives = hub.ActiveDownloadLimits
      ? JSON.parse(atob(hub.ActiveDownloadLimits))
      : []

    const selectedKeys = Array.isArray(actives)
      ? stations.filter((item) => {
        return actives.findIndex((id) => item.HardwareID === id) > -1
      }).map((item) => item.ID)
      : []

    const {getFieldDecorator} = form
    return (<Modal visible={visible} title={title} width={720} okText="Lưu" cancelText="Bỏ qua" onCancel={onCancel} onOk={onSubmit} footer={[
        <Button key="cancel" onClick={onCancel}>Bỏ qua</Button>,
        <Button key="submit" type="primary" ghost="ghost" onClick={onSubmit}>
          Lưu
        </Button>
      ]} className="modal-form">
      <Form layout="vertical">
        <FormItem label="">
          {
            getFieldDecorator('download', {
              initialValue: hub.FirmwareDownloadEnable,
              valuePropName: 'checked'
            })(<Checkbox>Enable download</Checkbox>)
          }
        </FormItem>
        <FormItem label="Danh sách trạm">
          {
            getFieldDecorator('selectedKeys', {
              initialValue: selectedKeys
            })(
              isMobile
              ? <StationTableMobileNonAction stations={stations} groups={groups} selectedKeys={selectedKeys} onSelectedKeys={this.handleSelectedKeys}/>
              : <StationTableNonAction stations={stations} groups={groups} selectedKeys={selectedKeys} onSelectedKeys={this.handleSelectedKeys}/>)
          }
        </FormItem>
      </Form>
    </Modal>);
  }
}

export default Form.create()(SystemHubUpgradeStationModalForm)



// WEBPACK FOOTER //
// ./src/components/SystemHubUpgradeStationModalForm.js